export default __webpack_public_path__ + "img/crew-management.40910b.svg";